// extracted by mini-css-extract-plugin
export default {"tableRow":"tableSpm_tableRow__Hfi0I","tableItem":"tableSpm_tableItem__xEx9C","titleItem":"tableSpm_titleItem__7gR+O"};